// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_ch-0";